import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-322">
      <div className="max-w-3xl mx-auto text-center" data-id="element-323">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-324">
          🚨 SI SOS ENTRENADOR O PROFE DE BOXEO,
          <br data-id="element-325" />
          <span className="text-[#F97316]" data-id="element-326">ESTO TE VA A SONAR FAMILIAR:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-327">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-328">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-329">❌</span>
            <div data-id="element-330">
              <p className="text-white text-lg font-medium" data-id="element-331">
                Llegás al gym sin saber exactamente qué ejercicio vas a dar hoy
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-332">
                <span className="text-[#F97316] font-semibold" data-id="element-333">
                  Lo que te cuesta:
                </span>{' '}
                Tiempo, energía y autoridad
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-334">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-335">❌</span>
            <div data-id="element-336">
              <p className="text-white text-lg font-medium" data-id="element-337">
                Tus alumnos nuevos no progresan porque no tenés una secuencia
                clara
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-338">
                <span className="text-[#F97316] font-semibold" data-id="element-339">
                  Lo que te cuesta:
                </span>{' '}
                Los perdés en los primeros 60 días
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-340">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-341">❌</span>
            <div data-id="element-342">
              <p className="text-white text-lg font-medium" data-id="element-343">
                El 70% abandona antes del año y no sabés cómo prevenirlo
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-344">
                <span className="text-[#F97316] font-semibold" data-id="element-345">
                  Lo que te cuesta:
                </span>{' '}
                Ingresos inestables mes a mes
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-346">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-347">❌</span>
            <div data-id="element-348">
              <p className="text-white text-lg font-medium" data-id="element-349">
                Cuando falta equipo o el espacio es chico, cancelás y perdés el
                ingreso
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-350">
                <span className="text-[#F97316] font-semibold" data-id="element-351">
                  Lo que te cuesta:
                </span>{' '}
                Plan B que nunca llega
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-352">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-353">❌</span>
            <div data-id="element-354">
              <p className="text-white text-lg font-medium" data-id="element-355">
                No podés justificar subir el precio porque no tenés un sistema
                visible
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-356">
                <span className="text-[#F97316] font-semibold" data-id="element-357">
                  Lo que te cuesta:
                </span>{' '}
                Seguís cobrando lo mismo de hace 3 años
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-358">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-359">❌</span>
            <div data-id="element-360">
              <p className="text-white text-lg font-medium" data-id="element-361">
                Siempre las mismas correcciones improvisadas sin un método que
                te respalde
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-362">
                <span className="text-[#F97316] font-semibold" data-id="element-363">
                  Lo que te cuesta:
                </span>{' '}
                Alumnos que no mejoran y se van
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-364">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-365">❌</span>
            <div data-id="element-366">
              <p className="text-white text-lg font-medium" data-id="element-367">
                Tenés alumnos de distintos niveles juntos y la clase se
                convierte en caos
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-368">
                <span className="text-[#F97316] font-semibold" data-id="element-369">
                  Lo que te cuesta:
                </span>{' '}
                Ni los nuevos aprenden ni los avanzados progresan
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-370">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-371">❌</span>
            <div data-id="element-372">
              <p className="text-white text-lg font-medium" data-id="element-373">
                Fin de mes y no sabés exactamente cuánto vas a cobrar
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-374">
                <span className="text-[#F97316] font-semibold" data-id="element-375">
                  Lo que te cuesta:
                </span>{' '}
                Ansiedad y dependencia del boca en boca
              </p>
            </div>
          </div>
        </div>

        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-8" data-id="element-376">
          💣 ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Orange divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#F97316] to-transparent w-full" data-id="element-377" />
      </div>
    </section>;
}